module.exports = {
  siteMetadata: {
    title: "Cloud Gateway | Flexible Networking and Security Solutions",
    author: {
      name: "The Bigger Boat",
      summary: "TBB Gatsby / Storyblok",
    },
    description:
      "The UK's first SASE platform, offering networking and security solutions for the public and private sector.",
    siteUrl: "https://www.cloudgateway.co.uk",
  },
  plugins: [
    {
      resolve: `gatsby-plugin-hotjar`,
      options: {
        includeInDevelopment: true, // optional parameter to include script in development
        id: 2337667,
        sv: 6,
      },
    },
    "gatsby-plugin-postcss",
    {
      resolve: "gatsby-source-storyblok",
      options: {
        stagingAccessToken: "BTgtpR3Tyh4CprkTe7YNiQtt",
        accessToken: "do6JvUykbLyoXfxWTksr7Qtt",
        homeSlug: "home",
        version: process.env.NODE_ENV === "production" ? "published" : "draft",
      },
    },
    {
      resolve: "gatsby-plugin-google-tagmanager",
      options: {
        id: "GTM-MHSJB6C",

        // Include GTM in development.
        //
        // Defaults to false meaning GTM will only be loaded in production.
        includeInDevelopment: false,

        // datalayer to be set before GTM is loaded
        // should be an object or a function that is executed in the browser
        //
        // Defaults to null
        defaultDataLayer: { platform: "gatsby" },

        // Name of the event that is triggered
        // on every Gatsby route change.
        //
        // Defaults to false
        enableWebVitalsTracking: true,
      },
    },
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        trackingIds: [
          "UA-38411868-2", // Google Analytics / GA
          "G-6JDQRQ3212",
        ],
        pluginConfig: {
          // Puts tracking script in the head instead of the body
          head: true,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /images/,
        },
      },
    },
    {
      resolve: `gatsby-plugin-breadcrumb`,
      options: {
        defaultCrumb: {
          location: {
            pathname: "/",
          },
          crumbLabel: "Home",
          crumbSeparator: " / ",
        },
        useAutoGen: true,
        trailingSlashes: true,
      },
    },
    {
      resolve: `gatsby-plugin-algolia`,
      options: {
        appId: "FVDPIDVXGF",
        apiKey: "84be934583c3453e3a4f7459ff6749c3",
        queries: require("./src/utils/AlgoliaQueries"),
      },
    },
    "gatsby-plugin-root-import",
    "gatsby-plugin-react-helmet",
    {
      resolve:"gatsby-plugin-sitemap",
      options: {
        exclude: [
          '/editor/',
        ],
      },
    },
    {
      resolve: `gatsby-plugin-react-helmet-canonical-urls`,
      options: {
        siteUrl: `https://www.cloudgateway.co.uk`,
      },
    },
    "gatsby-plugin-force-trailing-slashes",
    {
      resolve: "gatsby-plugin-robots-txt",
      options: {
        host: "https://cloudgateway.co.uk/",
        sitemap: "https://cloudgateway.co.uk/sitemap/sitemap-0.xml",
        policy: [
          {
            userAgent: "*",
            allow: "/",
            disallow: [
 	            "/*?sortBy",
              "/*?refinementList",
            ],
          }
        ],
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        start_url: `https://cloudgateway.co.uk/`,
        display: `standalone`,
        icon: `./static/cg-favicon.png`,      
      },
    },
  ],
};
